import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../../caseDecisions/common/Constants";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";

export default class AddCaseDecisionTypeIndexCategoriesInteractor {
  private createListResource: CreateListResourceInteractor<IDocumentTypeIndexCategory>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(
    organisationCaseDecisionTypeList: IDocumentTypeIndexCategory[],
    caseDecisionTypeId: number,
    organisationId: number
  ) {
    return this.createListResource.execute(
      `${Constants.caseDecisionTypesPath}/${caseDecisionTypeId}/organisations/${organisationId}`,
      organisationCaseDecisionTypeList,
      undefined,
      DocumentTypeIndexCategoryParamMapper
    );
  }
}
